$(document).ready(function() {

  $(".faq-answer").hide();
  $(".faq-question").click(function() {
    if($(this).hasClass("open")){
    $(".faq-answer").slideUp();
    $(this).removeClass("open");
    } else {
    $(".faq-answer").slideUp();
    $(this).addClass("open");
    $(this).next(".faq-answer").slideToggle();
    }
  });
  
  $(".phone-tile").click(function() {
    if ($(window).width() < 760) {
      window.open("tel:+16144544565")
    }
  });

});
